module.exports = __webpack_public_path__ + "img/375.8fb0041c.jpg";